export const initialState = {
    selectedTab:'',
    sideNavs:[],
    apiStatus:true,
    approvalFlowContext:'',
    approvalList:''
};

const ApprovalListReducer  = (state=initialState,action) => {
    switch(action.type){
        case 'SET_SELECTED_TAB':{
            return  {
                ...state,
                selectedTab:action.value
            }
        }
        case 'SET_SIDE_NAVS':{
            return  {
                ...state,
                sideNavs:action.value
            }
        }
        case 'SET_API_STATUS_VALUE':{
            return  {
                ...state,
                apiStatus:action.value
            }
        }
        case 'SET_APPROVAL_LIST':{
            return  {
                ...state,
                approvalList:action.value
            }
        }
        case 'SET_APPROVAL_FLOW_CONTEXT':{
            return  {
                ...state,
                approvalFlowContext:action.value
            }
        }
        default:
            return state;
    }

};

export default ApprovalListReducer;
